export function resolveCategoryActivity(categoryActivity = {}, categoryCode) {
  const hasCategory = Object.prototype.hasOwnProperty.call(categoryActivity, categoryCode);

  if (!hasCategory) return { value: null, empty: "—" };

  return {
    value: categoryActivity[categoryCode]?.lastAt || null,
    empty: "Nunca",
  };
}
